
export interface IExternalLoginResult {
    isValid: boolean;
    isLogin: boolean;
    status: ExternalLoginResultStatusCode;
}

export enum ExternalLoginResultStatusCode {
    GeneralError = -99,
    InsertError = -5,
    WavesAppValidationFailed = -4,
    DisabledUser = -3,
    EmailIsNotValid = -2,
    FacebookValidationFailed = -1,
    OK = 0,
}